import { styled } from '@mui/material';

export const ReviewContainer = styled('div')(() => ({
  display: 'flex',
}));

export const AvatarContainer = styled('div')(({ theme }) => ({
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));

export const ImageContainer = styled('div')(() => ({
  borderRadius: '50%',
  height: 0,
  overflow: 'hidden',
  paddingBottom: '100%',
  width: '50px',
}));

export const Image = styled('img')(() => ({
  display: 'block',
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
}));

export const ContentContainer = styled('div', { shouldForwardProp: prop => prop !== 'preview' })<{ preview: boolean }>(
  ({ preview, theme }) => ({
    ...(preview
      ? {
          borderBottom: `1px solid ${theme.palette.grey[800]}`,
          paddingBottom: theme.spacing(1),
        }
      : {}),
  }),
);

export const ContentInnerContainer = styled('div')(() => ({}));

export const SecondaryText = styled('span')(({ theme }) => ({
  color: theme.supportingTextPrimary,
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(1),
}));
